module.exports = __webpack_public_path__ + "img/asphalted_unstabilized.486e11e7.png";